/**
 * Storage Type for the EventBus (Local / Session).
 * 
 * We can opt out of storage by using the Disabled type.
 * 
 * Default: Session
 *
 * @export
 * @enum {number}
 */
export enum StorageType {
    Default = 'Session',
    Local = 'Local',
    Session = 'Session',
	Disabled = 'Disabled',
}